import dayjs from "dayjs"
import { NttData } from "../../types/diagnose.type"
import { convertDatetoDate } from "../../components/service-outage/helpers"

export function checkOutageNtt(data: NttData): boolean {
  const currDate = dayjs()

  // RetrieveLRInfo returns ErrorCode in PascalCase; commit 68fe9fd renamed it to
  // camelCase on the client, so this test has been comparing undefined ever
  // since. Read whichever spelling arrives rather than assuming one.
  // The comparison value itself is deliberately left as-is: the service omits
  // ErrorCode entirely on success (@JsonInclude(NON_NULL)), so "00" is likely
  // wrong too, but changing that alters when CTT creation is blocked and needs
  // to be decided separately.
  const errorCode = data.ErrorCode ?? data.errorCode

  if (errorCode === "00") {
    return true
  }
  if (data.ETTR) {
    if (currDate.isAfter(convertDatetoDate(data.ETTR))) {
      return false
    } else if (currDate.isBefore(convertDatetoDate(data.ETTR))) {
      return true
    } else {
      return false
    }
  }
  return false
}
